import { SET_SAMPLE_GROUP_DETAIL } from "@/store/mutation.type";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class SampleGroupMixin extends Vue {
  get groupDetail() {
    return this.$store.state["sample-group"].sampleGroupDetail;
  }
  set groupDetail(detail: any) {
    this.$store.commit(SET_SAMPLE_GROUP_DETAIL, detail);
  }
}
